import React from 'react';
import { Link } from 'react-router-dom';
import { Clock, Lock } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import './TrialBanner.css';

const timeLeft = (seconds) => {
  if (seconds >= 86400) {
    const days = Math.ceil(seconds / 86400);
    return `${days} day${days === 1 ? '' : 's'} left`;
  }
  const hours = Math.max(1, Math.ceil(seconds / 3600));
  return `${hours} hour${hours === 1 ? '' : 's'} left`;
};

// The free trial's days left, or, once it has ended, what still works and how to go on
export function TrialBanner() {
  const { user, isAdmin } = useAuth();
  const business = user?.business;
  if (!business || !['trial', 'expired'].includes(business.access)) return null;

  const action = isAdmin
    ? <Link className="btn btn-sm btn-primary trial-banner-action" to="/credits">Subscribe for $9/month</Link>
    : <span className="trial-banner-note">Ask an admin to subscribe.</span>;

  if (business.access === 'expired') {
    return (
      <div className="trial-banner is-ended" role="status">
        <Lock size={18} aria-hidden="true" />
        <p><strong>Your free trial has ended.</strong> Your orders and storage are safe. Subscribe to keep picking.</p>
        {action}
      </div>
    );
  }
  return (
    <div className="trial-banner" role="status">
      <Clock size={18} aria-hidden="true" />
      <p><strong>Free trial: {timeLeft(business.trial_seconds_left || 0)}.</strong> Then $9 a month, with 100 AI credits included.</p>
      {action}
    </div>
  );
}
